import React from 'react';

import { ItemsBlock } from './components';

const SearchPage = () => {
    return <ItemsBlock />;
};

export default SearchPage;
